module.exports = __webpack_public_path__ + "static/img/start-check.f3656b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/2/start-check.png
// module id = XEFE
// module chunks = 1